import React from "react";
import { BeatLoader } from "react-spinners";

const CenteredSpinner = (props) => {
  return (
    <div className="centered-spinner">
      <BeatLoader color="#fff" size={18} />
    </div>
  );
};

export default CenteredSpinner;
